export default {
  api_url: (process.env.NODE_ENV === 'production') ? 'https://lastmileallocationpod-api.xbees.in/' : 'https://lastmileallocationpod-apistage.xbees.in/',
  api_url_for_scantally: (process.env.NODE_ENV === 'production') ? 'https://scantallyapi.xbees.in/' : 'https://scantally-apistage.xbees.in/',
  tracker_url: (process.env.NODE_ENV === 'production') ? `${location.protocol}//track.xbees.in/` : `${location.protocol}//stageautoallocation-app.xbees.in/`,
  umurl: (process.env.NODE_ENV === 'production') ? `${location.protocol}//userauthentication.xbees.in/` : `${location.protocol}//stageusermanagement.xbees.in/`,
  //master_api_url: (process.env.NODE_ENV==='production')? 'http://xbmasterapi.xbees.in/':'http://stagexbmasterapi.xbees.in:3600/'
  //api_url: 'http://localhost:3800/',
  // api_url_for_scantally: 'http://localhost:9900/',
}



// WEBPACK FOOTER //
// ./src/constants.js